module.exports = __webpack_public_path__ + "img/20190918172426488.3656b22f.jpg";